import { createFileRoute, useParams } from "@tanstack/react-router";

import { PersonPage } from "@/components/explore/person-page";
import { contributorQuery, episodesInfiniteQuery } from "@/lib/queries";
import { queryClient } from "@/lib/query-client";

const PersonRoute = () => {
  const { contributorId } = useParams({ from: "/view/people/$contributorId" });

  return <PersonPage contributorId={contributorId} />;
};

export const Route = createFileRoute("/view/people/$contributorId")({
  component: PersonRoute,

  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData(contributorQuery(params.contributorId)),
      queryClient.ensureInfiniteQueryData(
        episodesInfiniteQuery(undefined, 30, params.contributorId)
      ),
    ]),
});
